import Slider from "react-slick"
import { diSanaImgs } from "@/app/utils/constants"
import clsx from "clsx"
import { useNavigate, useParams } from "react-router-dom";
import { useEffect, useRef, useState } from "react"
import { useGlobalContext } from "@/global/GlobalContext"
import NavEngrave from "@/assets/imgs/nav-engrave.png"
import { ProductCards } from "../../components/ProductCard"
import DefaultLayout from "@/layouts/Default"
import { LoadButton } from "@/components/Button";
import { ProductCardsRowSkeleton } from "@/components/skeletons/ProductCardSkeleton";
import Cookies from "js-cookie";

const DiSanaCategory = () => {
  const { pathname, categories, products, setProductRecomms } = useGlobalContext()
  const { slug } = useParams()
  const layoutRef = useRef()
  const navigate = useNavigate()
  const [page, setPage] = useState(1)
  const [hideLoadMoreBtn, setHideLoadMoreBtn] = useState(true)
  const [onReq, setOnReq] = useState(true)
  const [currProducts, setCurrProducts] = useState([])
  const settings = {
    dots: true,
    infinite: true,
    speed: 2100,
    slidesToShow: 1,
    slidesToScroll: 1,
    arrows: false,
    autoplay: true,
    autoplaySpeed: 2100,
    fade: true
  };

  useEffect(() => {
    Cookies.set("productsPage", page)
  }, [])

  useEffect(() => {
    if (categories.length > 0) {
      let selected = {}
      let diff = false

      selected = categories.find(val => val.slug == slug)

      if (!selected) {
        navigate("/page-not-found", { replace: true })
      } else {
        let selectedId = 0
        const storeCategoryId = Cookies.get("categoryId")

        if (storeCategoryId) {
          diff = !(parseInt(storeCategoryId) == selected.id)
          selectedId = parseInt(storeCategoryId) == selected.id ? storeCategoryId : selected.id
        } else {
          diff = true
          selectedId = selected.id
        }

        loadProduct(selectedId, page, false, diff)
      }
    }
  }, [pathname, categories])

  useEffect(() => {
    if (page > 1) {
      const selectedId = Cookies.get("categoryId")
      loadProduct(selectedId, page, true, false)
      Cookies.set("productsPage", page)
    }
  }, [page])

  useEffect(() => {
    if (products.length > currProducts.length) {
      setCurrProducts(products)
    }
    
    setHideLoadMoreBtn(layoutRef.current.getHideLoadMoreBtn())
  }, [products])

  const loadMoreProduct = () => {
    setPage(page + 1)
  }

  const loadProduct = async (id, page, loadMore, diff) => {
    setOnReq(true)
    await layoutRef.current.getProductByProdCategory(id, page, loadMore, diff)
    setOnReq(false)
  }

  return (
    <DefaultLayout ref={layoutRef}>
      <section className="w-full mt-16">
        <Slider {...settings} className="h-64 lg:h-80">
          {diSanaImgs.slides.map((s, i) => (
            <div key={i} className={clsx("h-64 lg:h-80 bg-cover bg-center bg-no-repeat", s)}></div>
          ))}
        </Slider>
        <div className="mb-12">
          <h2 className="mt-16 font-agcasmlt text-2xl sm:text-3xl md:text-4xl lg:text-5xl font-light text-[#7f766f] text-center mb-3">{products[0] && products[0].product_category?.name}</h2>
          <img img="100" src={NavEngrave} className="w-20 -mt-1 mx-auto" />
        </div>
        {onReq ? (
          products.length <= 0 ?
            <ProductCardsRowSkeleton count={6} />
            :
            <ProductCards products={currProducts} onReq={onReq} count={6} />
        ) : (
          products.length > 0 ?
            <ProductCards products={products} onReq={onReq} count={6} />
            :
            <div className=" pb-16">
              <p className="text-center text-gray-500">No product available.</p>
            </div>
        )}
        {!hideLoadMoreBtn && (
          <div className="py-8 text-center">
            <LoadButton onClickBtn={loadMoreProduct} />
          </div>
        )}
      </section>
    </DefaultLayout>
  )
}

export default DiSanaCategory